import { FaSearch } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import storeBgWave from "../../assets/images/storeBgWave.png";
import { resetData } from "../../features/login/LoginSlice";

import { useSelectStore } from "./useSelectStore";

const SelectStore = () => {
  const {
    stores,
    loading,
    error,
    search,
    handleChangeStore,
    totalCount,
    handleStoreSearch,
    initiallyHadData,
    authData,
  } = useSelectStore();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen bg-gray-100 p-4 flex justify-center items-center relative"
      style={{
        backgroundImage: `url(${storeBgWave})`,
        backgroundSize: "contain",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex items-center justify-between absolute top-0 p-4 w-full left-0">
        <img
          src="/iAugment-logo-color.png"
          alt="Logo"
          className="h-12 max-w-full object-cover"
        />
        <button
          className="px-3.5 py-1.5 bg-red-500 text-white rounded hover:bg-red-600 outline-none focus:outline-none text-sm font-sans"
          onClick={() => {
            dispatch(resetData());
            navigate("/login");
          }}
        >
          Logout
        </button>
      </div>
      <div className="max-w-[650px] mx-auto bg-white rounded-lg shadow-md w-full p-4">
        <h3 className="text-xl font-semibold text-gray-800 pb-2">
          Select Store
        </h3>
        <div className="py-2">
          <div className="flex">
            <div className="flex-1">
              <input
                type="search"
                name="search"
                id="storeSearch"
                value={search}
                onChange={handleStoreSearch}
                className="w-full border-l border-t border-b border-r-0 p-2 pl-3 pr-4 rounded-tl-md rounded-bl-md focus:outline-none"
                disabled={!initiallyHadData}
                placeholder="Search stores..."
              />
            </div>
            <div className="flex items-center justify-center px-2.5 bg-gray-100 border border-l-0 rounded-tr-md rounded-br-md">
              <FaSearch size={16} className="text-gray-400" />
            </div>
          </div>
        </div>
        {loading ? (
          <p>loading...</p>
        ) : !error ? (
          stores.length > 0 ? (
            <>
              <div className="max-h-[300px] overflow-y-auto pr-2 ">
                {stores.map((store) => (
                  <div
                    key={store.iStoreId}
                    className={`py-3 px-2.5 border-b border-gray-200 cursor-pointer flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors duration-150 `}
                    onClick={() => {
                      handleChangeStore(store);
                    }}
                  >
                    <div className="flex-1">
                      <p className="text-gray-600 m-0 font-medium">
                        {store.sName} ({store.sStoreTypeName} {store.sStoreType}
                        )
                      </p>
                      <div className="text-xs text-gray-500 mt-1 flex gap-4">
                        <span>
                          Pending Products:{" "}
                          <span className="text-gray-800 font-semibold">
                            {store.iPendingProductCount ?? 0}
                          </span>
                        </span>
                        <span>
                          Pending Variants:{" "}
                          <span className="text-gray-800 font-semibold">
                            {store.iPendingVariantCount ?? 0}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : !search && totalCount === 0 && !initiallyHadData ? (
            <Link
              to="/stores"
              className="text-blue-500 text-center cursor-pointer no-underline block"
            >
              Add Store
            </Link>
          ) : (
            <p className="text-center text-gray-400 text-sm py-2">
              No Such Store Exist
            </p>
          )
        ) : (
          <p className="text-center text-red-500 text-sm">{error}</p>
        )}
      </div>
    </div>
  );
};

export default SelectStore;
